import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { Icon } from '../../../components/common/icon/Icon';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';

export const RequestConsultSection = () => {
  const handlePluvaAutoInquiryButton = () => {
    ampli.오토최저가문의버튼클릭();
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'link', messageParam: 'tel:15335502' });
    } else {
      window.location.href = 'tel:15335502';
    }
  };

  return (
    <Container>
      <TopSection>
        <Title>{'낮은 자부담 구매엔?\n정답은 플루바 오토!'}</Title>
        <SubTitle>
          {'해마다 100명 이상 농민분들이\n농기센터, 시군구 보조사업 등으로\n낮은 자부담 구매에 성공하고 있어요.'}
        </SubTitle>
      </TopSection>
      <BottomSection>
        <Button onClick={handlePluvaAutoInquiryButton}>
          <ButtonMainTextWrapper>
            <Icon name={'Phone'} width={20} height={20} fill={'#fff'} />
            <ButtonMainText>{'1533-5502'}</ButtonMainText>
            <ButtonSubText>{'간편 문의 전화'}</ButtonSubText>
          </ButtonMainTextWrapper>
        </Button>
      </BottomSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 48px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  white-space: pre-line;
`;

const Title = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const SubTitle = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

const BottomSection = styled.div`
  display: flex;
  padding: 0px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
`;

const HorizontalLine = styled.hr`
  width: 100%;

  height: 0px;
  align-self: stretch;
  stroke-width: 1px;
  stroke: #e4e4ed;
`;

const ImageButton = styled.img`
  width: 197px;
  height: 81px;
  cursor: pointer;
`;

const Button = styled.button`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);

  cursor: pointer;
`;

const ButtonMainTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const ButtonMainText = styled.h4`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const ButtonSubText = styled.h5`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;
